import React from "react";
import style from "./index.module.scss";
import moment from "moment";

interface BadgeCorProps {
    timeDate?: string;
    startTime: string;
    endTime: string;
}

export default function BadgeCor({
    timeDate,
    startTime,
    endTime
}: BadgeCorProps) {
    //获取时间并且格式化
    const date = moment(timeDate).format("YYYY-MM-DD");
    //课程开始时间
    const before = date + " " + startTime.padStart(5, "0");
    const beforeTime = moment(before);

    //课程结束时间
    const after = date + " " + endTime.padStart(5, "0");
    const afterTime = moment(after);

    function renderBadge() {
        if (afterTime.isBefore(moment()))
            return (
                <div className={`${style.badge} ${style.end}`}>
                    <p>已结束 </p>
                </div>
            );

        if (beforeTime.isAfter(moment()))
            return (
                <div className={`${style.badge} ${style.noStart}`}>
                    <p>未开始</p>
                </div>
            );

        return (
            <div className={style.badge}>
                <p>进行中</p>
            </div>
        );
    }

    return <div className={style.root}>{renderBadge()}</div>;
}
